<script setup lang="ts">
type MarkdownPanelProps = {
  title?: string
  text?: string
  supportingData?: {
    home: {
      titleSize?: {
        value: number
      }
    }
  }
}

const props = withDefaults(defineProps<MarkdownPanelProps>(), {})
const headingLevel = props.supportingData?.home?.titleSize?.value || 2
</script>

<template>
  <section class="markdown-panel" data-testid="markdown-panel">
    <div class="container">
      <component :is="`h${headingLevel}`" v-if="title" class="markdown-panel__section-title">
        {{ title }}
      </component>
      <Markdown v-if="text" :content="text" />
    </div>
  </section>
</template>

<style lang="postcss">
.markdown-panel {
  margin-bottom: var(--component-space);
  text-align: center;

  .container {
    max-width: 58.875rem; /* 942px */
  }
}
</style>
